module.exports = __webpack_public_path__ + "static/img/award1_a.cf2f743.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award1_a.png
// module id = cBc+
// module chunks = 7